import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import type { TabContent } from '../../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import { FilterId } from '../../filters/types/filters';
import {
  SUBSIDIARY_CHART_POSITION,
  subsidiarySnapshotCards,
  subsidiaryTrendCards,
} from './subsidiary-side-cards';

const items: TabContent['items'] = [
  {
    id: 'company-subsidiaries-icicle',
    title: 'Corporate Structure',
    isTitleManuallySet: true,
    info: {
      text: 'The selected company’s subsidiaries, up to four levels deep, sized by employees. Smaller ones are grouped into Other. Click a company to focus on it; use the breadcrumb to go back.',
    },
    position: SUBSIDIARY_CHART_POSITION,
    plot: {
      chartType: 'icicle',
      defaultMetricOptions: ['headcount'],
      secondaryDimension: 'subsidiaries',
      primaryEntitySwitcher: true,
    },
  },
  ...subsidiarySnapshotCards('company-subsidiaries'),
];

const companySubsidiariesTab: TabContent = {
  id: 'company-subsidiaries',
  items,
  primaryFilter: {
    id: FilterId.COMPANY,
  },
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [{ id: FilterId.SNAPSHOT_DATE }],
};

const overTimeItems: TabContent['items'] = [
  {
    id: 'company-subsidiaries-over-time',
    title: 'Corporate Structure',
    isTitleManuallySet: true,
    info: {
      text: 'When each subsidiary joined the group. The largest direct subsidiaries get a line each, named on the right; the rest share the last one. Lines run from founding to the date a company joined its parent; circles mark smaller companies. Click a line or name to focus on it.',
    },
    position: SUBSIDIARY_CHART_POSITION,
    plot: {
      chartType: 'timeline',
      defaultMetricOptions: ['headcount'],
      secondaryDimension: 'subsidiaries',
      primaryEntitySwitcher: true,
    },
  },
  ...subsidiaryTrendCards('company-subsidiaries-over-time'),
];

const companySubsidiariesOverTimeTab: TabContent = {
  id: 'company-subsidiaries-over-time',
  items: overTimeItems,
  primaryFilter: {
    id: FilterId.COMPANY,
    tagColors: true,
  },
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [{ id: FilterId.DATE_RANGE }],
};

export const companySubsidiaries: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.COMPANY_SUBSIDIARIES,
  revelioPageId: RevelioPageId.COMPANY_SUBSIDIARIES,
  name: 'Corporate Structure',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'company-subsidiaries',
      label: 'Snapshot',
      tabContent: companySubsidiariesTab,
      isActive: true,
    },
    {
      id: 'company-subsidiaries-over-time',
      label: 'Over Time',
      tabContent: companySubsidiariesOverTimeTab,
      isActive: false,
    },
  ],
};
